import { useState } from "react";
import SEOMetadata from "../../components/SEOMetadata";
import { seoConfig } from "../../config/seoConfig";
import Benefits from "../../components/allModels/benefits";
import BuiltWork from "../../components/allModels/builtWork";
import EfiModel from "../../components/allModels/efiModel";
import FeatureCard from "../../components/allModels/featureCard";
import GasPowerBennar from "../../components/allModels/gasPowerBennar";
import GoFaster from "../../components/allModels/goFaster";
import MachineInfoCard from "../../components/allModels/machineInfoCard";
import BuildTuatara from "../../components/home/buildTuatara/buildTuatara";
import DealerLocator from "../../components/home/dealerLocator/dealerLocator";
import TuataraMotion from "../../assets/png/Tuatara_in_motion.png";
import Tuatara_with_trailer from "../../assets/images/Tuatara_with_trailer.JPG";
import ArielView1500E from "../../assets/png/ArielView1500E.png";
import TuataraHVAC from "../../assets/png/TuataraHVAC.png";
import GASOLINEIMG from "../../assets/png/1000_EFI _GASOLINE.png";
import GravelRoad from "../../assets/png/Gravel_Road.png";
import Rectangle from "../../assets/png/Rectangle.png";

import Electric_Vehicle_One from "../../assets/images/1500EFIImg/1500E-2.png";
import Electric_Vehicle_Two from "../../assets/images/1500EFIImg/1500E-3.png";
import Electric_Vehicle_Three from "../../assets/images/1500EFIImg/1500Ewithnewdoors4.jpg";
import Electric_Vehicle_Four from "../../assets/images/1500EFIImg/1500Enewdoors8.jpg";
import Electric_Vehicle_Five from "../../assets/images/1500EFIImg/1500E21500E3(2).png";
import Electric_Vehicle_Six from "../../assets/images/1500EFIImg/1500E21500E3(3).png";
import Electric_Vehicle_Seven from "../../assets/images/1500EFIImg/1500E21500E3(4).jpg";
import PETROLSIDE1 from "../../assets/images/1500EFIImg/1500E21500E3Title photo.png";


import usePageTitle from "../../hooks/usePageTitle";

const OneThousandFiveHundredModelTwo = () => {
  usePageTitle("TU-1500E-2");

  const infoArray = [
    "ELECTRIC POWER",
    "POWER TILT BED",
    "TRANSFORMING CARGO BED",
  ];
  const [info, setInfo] = useState([
    {
      title: "ECO-FRIENDLY",
      subTitle: "Zero Emissions, Quiet Performance",
      dec: "The electric-powered Tuatara is designed for durability and sustainability, making it a versatile utility vehicle for any job. Its electric motor provides a range of 30-50 miles on a single charge with a top speed of 27 MPH, and a load capacity of 2,200 lbs. Built with all-steel construction and anti-rust treatment, it’s engineered to handle tough terrain while offering a greener, low-maintenance alternative to traditional gas-powered UTVs. Ideal for both work and off-road adventures, the electric Tuatara combines eco-friendly power with rugged performance, making it perfect for industries and environments that demand both strength and sustainability.",
      img: TuataraMotion,
    },
    {
      title: "POWER BED TILT",
      subTitle: "Power Tilt on Cargo Bed, Flat Bed, and Trailer",
      dec: "The Tuatara utility vehicle is equipped with a power tilt system that allows for easy lifting and dumping of the cargo bed, making it ideal for transporting and unloading heavy loads efficiently.",
      dec2: "When combined with a trailer, the power tilt system ensures quick and effortless loading and unloading, making Tuatara an exceptional choice for industries like agriculture, construction, and waste management, where adaptability and efficiency are crucial.",
      img: Tuatara_with_trailer,
    },

    {
      title: "EVOLVES TO YOUR CARGO",
      subTitle: "Easily Convert the Cargo Bed to a Flat Bed",
      dec: "The Tuatara is built with adaptability in mind, allowing it to easily evolve to meet the demands of any job. One of its standout features is the ability to convert the cargo bed into a flat bed, offering greater versatility for hauling larger or irregular loads. This quick-change capability makes the Tuatara ideal for industries where different tasks require flexible solutions. ",
      dec2: "Whether you need a standard cargo bed for transporting equipment or a flat bed for oversized materials, the Tuatara is designed to adjust and keep you moving efficiently.",
      img: ArielView1500E,
    },
  ]);

  const [machineInfo, setMachineInfo] = useState([
    {
      img: PETROLSIDE1,
      title: "TU-1500E-2",
      subTitle: "ELECTRIC POWERED UTILITY VEHICLE",
      btnName: "EXPLORE 1000EFI",
      thumbnails: [
        PETROLSIDE1,
        // Electric_Vehicle_Three,
        // Electric_Vehicle_Four,
        Electric_Vehicle_Five,
        Electric_Vehicle_Six,
        Electric_Vehicle_Seven
      ],
      features: [
        "15kW Electric Motor",
        "Lithium Iron Phosphate Battery",
        "2WD / 4WD Selectable Drive",
        "2,200 lbs Payload Capacity",
      ],
      specSheetUrl: "/assets/pdf/TUATARA1500ESinglemotor3seat SPEC SHEET.pdf",
    },
  ]);

  const [modelInfo, setModelinfo] = useState({
    title: (
      <div className="flex font-[Rockwell] 2xl:text-[40px] xl:text-[35px] lg:text-[30px] md:text-[25px] sm:text-[20px] text-[17px] font-extrabold ">
        <span className="underline  lg:decoration-[5px] sm:decoration-[4px] decoration-[2px] lg:underline-offset-[24px] md:underline-offset-[18px] sm:underline-offset-[15px] underline-offset-[8px] decoration-[#7ABF5B]">
          1500E
          <span className="underline  lg:decoration-[5px] sm:decoration-[4px] decoration-[2px] lg:underline-offset-[24px] md:underline-offset-[18px] sm:underline-offset-[15px] underline-offset-[8px] !decoration-[#fff]">
            {" "}
            Model
          </span>
        </span>
      </div>
    ),
    dec: `The electric-powered Tuatara is designed for durability and sustainability, making it a versatile utility vehicle for your job. Its electric motor provides a range of 30 miles on a single charge with a top speed of 27 MPH, and a load capacity of 2,200 lbs. Built with all-steel construction and anti-rust treatment, it’s engineered to handle tough terrain while offering a greener, low-maintenance alternative to traditional gas-powered UTVs. Ideal for both work and off-road adventures, the electric Tuatara is perfect for industries and environments that demand both strength and sustainability.`,
  });

  const GoFasterInfo = {
    title: "GO ELECTRIC, GO ANYWHERE",
    list: [
      "12-26.5 KWH PRO BATTERY",
      "3.5 HR RAPID CHARGE & OPPORTUNITY CHARGING",
    ],
    info: [
      `Our 12 to 26.5kWh pro batteries double your range, giving you up to 30-50 miles of continuous use. Whether it's long days in the field or extended off-road adventures, the Tuatara’s enhanced battery options ensure you have the power you need.`,
      `The electric Tuatara comes equipped with a 3.5-hour rapid charge system, minimizing downtime and keeping you productive. This fast-charging capability means that even during a busy workday, you can recharge quickly and get back to the job. Plus, with opportunity charging, you can top up your battery at any point, keeping you moving.`,
    ],
  };

  const BenefitsInfo = [
    {
      title: "ECO-FRIENDLY PERFORMANCE",
      subTitle:
        "With zero emissions, the electric Tuatara offers an environmentally sustainable option for any job or adventure.",
    },
    {
      title: "LOW MAINTENANCE",
      subTitle:
        "Fewer moving parts compared to gas-powered vehicles means reduced maintenance costs and longer lifespan.",
    },
    {
      title: "QUIET OPERATION & IMPROVED COMFORT",
      subTitle:
        "Quieter, more spacious cab with improved visibility helps operators work more productively throughout the day. Ideal for environments requiring low noise, such as farms, parks, or residential areas.",
    },
  ];
  const seoData = seoConfig.us.tu1500e2;

  return (
    <>
      <SEOMetadata
        title={seoData.title}
        description={seoData.description}
        keywords={seoData.keywords}
      />
      <GasPowerBennar
        title={modelInfo.title}
        description={modelInfo.dec}
        bannerText="ELECTRIC"
      />
      <EfiModel modelInfo={modelInfo} hideTitle={true} hideDescription={true} />
      <MachineInfoCard activeMachine={machineInfo} />
      <GoFaster GoFasterInfo={GoFasterInfo} />
      <Benefits BenefitsInfo={BenefitsInfo} />
      {/* <DealerLocator /> */}
      <FeatureCard />
      <BuiltWork info={info} infoArray={infoArray} />
      <BuildTuatara />
    </>
  );
};
export default OneThousandFiveHundredModelTwo;
